import { UserType } from 'app/types/User';

export function userTypeToDisplayName(enumValue: UserType) {
  switch (enumValue) {
    case UserType.Portal:
      return 'Portal';
    case UserType.ApiOnly:
      return 'API only';
    default:
      return 'Unknown';
  }
}
